import React, { useState, useEffect } from 'react'
import { useEventBus } from 'shared/providers/EventBusProvider'

export const EventBusDebugger: React.FC = () => {
    const { activeEvents, bus } = useEventBus()
    const [eventsLog, setEventsLog] = useState<Array<{ event: string; data: any; timestamp: Date }>>([])
    const [isCollapsed, setIsCollapsed] = useState(false)

    useEffect(() => {
        const listeners: Array<{ event: string; unsubscribe: () => void }> = []

        activeEvents.forEach((event: any) => {
            const unsubscribe = bus.on(event, (data: any) => {
                setEventsLog(prev => [
                    { event, data, timestamp: new Date() },
                    ...prev.slice(0, 49)
                ])
            })

            listeners.push({ event, unsubscribe })
        })

        return () => {
            listeners.forEach(({ unsubscribe }) => unsubscribe())
        }
    }, [
        activeEvents, bus
    ])

    if (isCollapsed) {
        return (
            <button
                onClick={() => setIsCollapsed(false)}
                style={{
                    position: 'fixed',
                    bottom: 20,
                    right: 20,
                    zIndex: 9999,
                    background: '#333',
                    color: 'white',
                    padding: '8px 12px',
                    borderRadius: 4,
                    border: 'none',
                    cursor: 'pointer'
                }}
                >
                🐛 Debug ({eventsLog.length})
            </button>
        )
    }

    return (
        <div style={{
            position: 'fixed',
            bottom: 20,
            right: 20,
            width: 400,
            maxHeight: 500,
            backgroundColor: '#1e1e1e',
            color: '#d4d4d4',
            borderRadius: 8,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'monospace',
            fontSize: 12
        }}>
            <div style={{
            padding: '8px 12px',
            backgroundColor: '#333',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer'
            }} onClick={() => setIsCollapsed(true)}>
            <strong>🔍 Event Bus Debugger</strong>
            <span>✕</span>
            </div>
            
            <div style={{ padding: 8, borderBottom: '1px solid #444' }}>
            <strong>Active Events:</strong>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                {activeEvents.length === 0 ? (
                <span style={{ color: '#888' }}>No active events</span>
                ) : (
                activeEvents.map(event => (
                    <span key={event} style={{
                    backgroundColor: '#007acc',
                    padding: '2px 6px',
                    borderRadius: 4,
                    fontSize: 11
                    }}>
                    {event}
                    </span>
                ))
                )}
            </div>
            </div>
            
            <div style={{ flex: 1, overflowY: 'auto', padding: 8 }}>
            <strong>Event Log:</strong>
            {eventsLog.length === 0 ? (
                <div style={{ color: '#888', marginTop: 8 }}>No events emitted yet</div>
            ) : (
                eventsLog.map((log, idx) => (
                <div key={idx} style={{
                    borderBottom: '1px solid #444',
                    padding: '4px 0',
                    marginTop: 4
                }}>
                    <div style={{ color: '#4ec9b0' }}>{log.event}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>
                    {log.timestamp.toLocaleTimeString()}
                    </div>
                    <pre style={{ margin: '4px 0 0 0', fontSize: 10, overflow: 'auto' }}>
                    {JSON.stringify(log.data, null, 2)}
                    </pre>
                </div>
                ))
            )}
            </div>
            
            <button
            onClick={() => setEventsLog([])}
            style={{
                margin: 8,
                padding: 4,
                backgroundColor: '#444',
                color: 'white',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer'
            }}
            >
            Clear Log
            </button>
        </div>
    )
}